import { render } from "./TeamInfo.vue?vue&type=template&id=a90eae2c&scoped=true"
import script from "./TeamInfo.vue?vue&type=script&lang=js"
export * from "./TeamInfo.vue?vue&type=script&lang=js"

import "./TeamInfo.vue?vue&type=style&index=0&id=a90eae2c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90eae2c"]])

export default __exports__